//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'

export default {
  name: "contentItem",
  props: [
    'title',
    'url',
    'imageUrl',
    'postDate',
    'postDetail'
  ],
  computed: {
    postDateString: function(){
      return moment(this.postDate).format('DD MMMM YYYY')
    }
  },
  data() {
    return {
      
    };
  },
}
